export const QuotationStatus = [
  "Requested",
  "Quoted",
  "Re-Requested",
  "Re-Quoted",
  "Approved by customer",
  "Rejected by customer",
  "Cancelled by customer",
]
